import { forwardRef, useEffect, useState } from "react";
import { schedulePolicyRepayment } from "../../utils/helpers/functions";
import LOGO from "../../assets/images/logos/logo.png";
import moment from "moment";

const PolicyPaymentSchedule = forwardRef(({ data }, ref) => {

    const [scheduleRepayment, setScheduleRepayment] = useState(null);

    useEffect(() => {
        window.scrollTo({
          top: 0,
          // behavior: "smooth",
        });
      }, []);

      useEffect(() => {
        if (data) {
          let schedule = schedulePolicyRepayment(
            data?.effectiveDate,
            data?.endDate,
            data?.repayment_frequency,
            data?.total_premium
          );
          setScheduleRepayment(schedule);
        }
      }, [data]);

      
  return (
    <div ref={ref}>
        <div className='d-flex flex-column justify-content-center align-items-center'>
            <img src={LOGO} alt='logo' width={100} />
            <h4
            className='text-uppercase text-primary fw-bold'
            style={{ fontSize: "30px", color: "#2e3192" }}
            >
            PRUDENT CHOICE MICROINSURANCE
            </h4>
        </div>
        <div className='row mt-3'>
            <div
                className='mx-2 py-1 text-center border '
                style={{ maxWidth: "96.5%" }}
            >
                SAVINGS PREMIUM PAYMENT BREAKDOWN
            </div>
            <div className='col-md-12'>
                <table class='table table-bordered"'>
                <thead
                    class='thead-blue'
                    style={{
                    backgroundColor: "#727CF5",
                    textAlign: "center",
                    color: "#FFFFFF",
                    }}
                >
                    <tr>
                    <th scope='col'>Date</th>
                    <th scope='col'>Premium (&#8358;)</th>
                    </tr>
                </thead>
                <tbody style={{ textAlign: "center" }}>
                    {scheduleRepayment?.map((schedule, i) => {
                    return (
                        <tr key={i}>
                        <td>{moment(schedule.date).format("D-M-Y")}</td>
                        <td>{schedule?.amount}</td>
                        </tr>
                    );
                    })}
                    <tr>
                    {data?.repayment_frequency === "one-off" ? (
                        <td className='fw-bold'>
                        {moment(new Date()).format("D-M-Y")}
                        </td>
                    ) : (
                        <td className='fw-bold'>Total</td>
                    )}
                    <td className='fw-bold'>
                        {parseFloat(data?.total_premium)?.toFixed(2)}
                    </td>
                    </tr>
                </tbody>
                </table>
            </div>
        </div>
    </div>
  )
})

export default PolicyPaymentSchedule